<template>
  <template v-if="styleType === 'advanced'">
    <div class="rank" v-if="level > 0">
      <img class="rank-icon" :src="icon" />
      <span class="rank-name">{{ levelName }}</span>
    </div>
    <van-tag class="s" v-else plain type="primary">{{ computedLevelName }}</van-tag>
  </template>
  <div v-else class="van-hairline--surround common-level ml-4px text-11px p-2px text-[#999]">
    {{ computedLevelName }}
  </div>
</template>
<script setup>
// import {useUserStore} from '@/store/user'
import { computed } from 'vue'
// import { getLocal } from '@/common/js/utils'
import { Tag as vanTag } from 'vant'

const props = defineProps({
  level: { type: [Number, String] },
  levelName: { type: String },
  styleType: { type: String, default: 'advanced' } // advanced 高级  common 普通
})

const computedLevelName = computed(() => {
  if (props.level === -2) {
    return '微信用户'
  } else if (props.level === -1) {
    return '注册用户'
  } else {
    return props.levelName
  }
})
// const userStore = useUserStore()
// const projectInfo: any = getLocal('projectInfo')
// const info = ref(projectInfo?.levelList.find(it => it.level === props.level || it.levelName === props.levelName))
const icon = 'https://x.jzbull.com/x_dsx_h5admin/icons/rank.png'
</script>
<style lang="less" scoped>
.rank {
  box-sizing: border-box;
  font-size: 10px;
  padding: 2px 8px;
  margin-left: 8px;
  background: linear-gradient(90deg, #423025 0%, #7a4b1e 100%);
  border-radius: 11px;
  display: flex;
  align-items: center;
  .rank-icon {
    display: inline-block;
    width: 13px;
    height: 13px;
  }
  .rank-name {
    padding-left: 4px;
    color: #ffe2bd;
    font-size: 10px;
  }
}
:deep(.van-tag) {
  font-size: 12px !important;
  color: #ffff00;
}
.common-level ::before,
::after {
  border-color: rgb(153, 153, 153, 0.5);
  border-radius: 6px;
}
</style>
